import React from "react"
import CopyButton from "../../Ui/CopyButton"

import { Email, StyledTableRow, Wrapper } from "./ApiKey.styled"

import { ReactComponent as EmailIcon } from "images/icons/paper-plane.svg"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  sendAs: string
  name: string
  value: string
  icon: React.ReactNode
}

export const ApiKey = ({ sendAs, name, value, icon }: Props) => (
  <Wrapper>
    <TableHeader iconHeader={true}>
      <div className="hideOnSmallScreens">Send as</div>
      <div>Name</div>
      <div>Value</div>
    </TableHeader>
    <StyledTableRow>
      {icon}

      <div className="hideOnSmallScreens">
        <b>{sendAs}</b>
      </div>
      <div>
        <b>{name}</b>
        <CopyButton string={name} />
      </div>
      <div>
        {value === "Contact Brink support" ? (
          <Email href="mailto:merchantsupport@brinkcommerce.com">
            <b>{value}</b>
            <EmailIcon />
          </Email>
        ) : (
          <>
            <b>{value}</b>
            <CopyButton string={value} />
          </>
        )}
      </div>
    </StyledTableRow>
  </Wrapper>
)
